function ServiceFinder() {

    let finders = document.querySelectorAll('.service-finder');

    if (finders.length && typeof window.service_finders !== 'undefined') {
        for (let i = 0; i < finders.length; i++) {
            this.initFinder(finders[0], window.service_finders[0]);
        }
    }

}

ServiceFinder.prototype.initFinder = function (el, json) {

    this.json = json;
    this.anchor = el.querySelector('a.target');
    this.first_header = el.querySelector('.selectblock.i-am .selectblock__header');
    this.first_options = el.querySelector('.selectblock.i-am .selectblock__options');
    this.second_header = el.querySelector('.selectblock.looking-for .selectblock__header');
    this.second_options = el.querySelector('.selectblock.looking-for .selectblock__options');
    this.first_select = el.querySelector('select.i-am');
    this.second_select = el.querySelector('select.looking-for');

    this.selected = {
        'i-am': null,
        'looking-for': null
    }

    if (!this.first_options || !this.second_options || !this.first_select || !this.second_select || !this.anchor) return;

    var $this = this;

    this.first_options.addEventListener('click', function(event) {
        if (event.target.tagName == 'LI') {
            $this.onFirstSelectChange(event.target.dataset.value); 
            $this.changeSelect(event.target.dataset.value, $this.first_select);
        }
    });
    
    this.second_options.addEventListener('click', function(event) {
        if (event.target.tagName == 'LI') {
            $this.onSecondSelectChange(event.target.dataset.value);
            $this.changeSelect(event.target.dataset.value, $this.second_select);
        }
    });

    this.first_select.addEventListener('change', function(event) { $this.onFirstSelectChange(event.target.value); });
    this.second_select.addEventListener('change', function(event) { $this.onSecondSelectChange(event.target.value); });
 
}

ServiceFinder.prototype.onFirstSelectChange = function (value) {
    this.selected['i-am'] = value;
    this.first_header.innerHTML = value;
    let second_dropdown_options = [];

    this.first_header.classList.remove('clicked');
    this.first_options.classList.remove('show');

    for (let i = 0; i < this.json.length; i++) {
        if (this.json[i].dropdown_1 == value) {
            second_dropdown_options.push(this.json[i].dropdown_2);
        }
    }

    let option_html = this.getOptionHtml(second_dropdown_options);
    let select_option_html = this.getSelectOptionHtml(second_dropdown_options);
    this.second_options.innerHTML = option_html;
    this.second_select.innerHTML = select_option_html;
    this.onSecondSelectChange(second_dropdown_options[0]);
}

ServiceFinder.prototype.onSecondSelectChange = function (value) {
    this.selected['looking-for'] = value;
    this.second_header.innerHTML = value;
    this.second_header.classList.remove('clicked');
    this.second_options.classList.remove('show');
    let url = this.getUrl();
    if (url) {
        this.anchor.href = url;
    }
}

ServiceFinder.prototype.getUrl = function () {

    let dropdown_1 = this.selected['i-am'];
    let dropdown_2 = this.selected['looking-for'];

    for (let i = 0; i < this.json.length; i++) {
        if (this.json[i].dropdown_1 == dropdown_1 && this.json[i].dropdown_2 == dropdown_2) {
            return this.json[i].link;
        }
    }
    return false;
}

ServiceFinder.prototype.getOptionHtml = function (options) {
    let html = '';
    for (let i = 0; i < options.length; i++) {
        html += '<li data-value="'+ options[i] +'">' + options[i] + '</li>';
    }
    return html;
}

ServiceFinder.prototype.getSelectOptionHtml = function (options) {
    let html = '';
    for (let i = 0; i < options.length; i++) {
        html += '<option value="'+ options[i] +'">' + options[i] + '</option>';
    }
    return html;
}

ServiceFinder.prototype.changeSelect = function (value, select) {
    select.value = value;
}

export default ServiceFinder;


// WEBPACK FOOTER //
// ./js/components/service-finder/index.js